import Rollbar from 'rollbar';
import { App, Plugin } from 'vue';

const rollbarConfig = {
	accessToken: '15150809421845f68997f6c9765277ee',
	captureUncaught: false,
	captureUnhandledRejections: false,
	payload: {
		environment: CONFIG.STAGE,
	},
};

const GlobalsPlugin: Plugin = {
	install: (app: App<Element>): void => {
		const rollbar = new Rollbar(rollbarConfig);

		app.config.errorHandler = (error: any): void => {
			if (rollbar === null) {
				return;
			}

			if (CONFIG.STAGE === 'prd') {
				rollbar.error(error);
			}

			throw error;
		};
	},
};

export { GlobalsPlugin };
